export default "assets/images/logo-9fb3166a.png";